<template>
  <div class="compliance-filter level no-margin">
    <div class="level-left" v-if="headerText != 'product'">
      <div class="custom-dropdown countries">
        <custom-dropdown
          :dropdownList="filterCountry"
          :inputBoxText="'Countries'"
          @valueSelected="selectCountries"
          :preSelectedValue="selectedCountry"
          :isCountry="true"
        ></custom-dropdown>
      </div>
      <div class="custom-dropdown">
        <custom-dropdown
          :dropdownList="filterScheme"
          :inputBoxText="'Schemes'"
          @valueSelected="selectedSchemes"
          :preSelectedValue="selectedScheme"
        ></custom-dropdown>
      </div>
      <div>
        <b-dropdown v-model="selectedSortOptions" aria-role="list">
          <template #trigger>
            <button class="button dropdown-button" type="button">
              <span> By {{ selectedSortOptions.name }}</span>
              <b-icon icon="menu-down"></b-icon>
            </button>
          </template>

          <b-dropdown-item
            v-for="(option, index) in dropdownList"
            aria-role="listitem"
            :key="index"
            @click="selectedValue(option)"
          >
            <span>{{ option.name }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="level-left country-for-product" v-else>
      <multiselect
        v-model="countryForProduct"
        @input="loadProductByCountry"
        track-by="name"
        label="name"
        placeholder="Select one"
        :options="filterCountry"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
      >
        <template slot="singleLabel" {{ option.name }}></template>
      </multiselect>
    </div>
    <div class="level-right">
      <div class="compliance-filter-date-picker date-range-picker">
        <span>Date Range (Sales Date)</span>
        <date-picker
          ref="datePicker"
          v-model="filterRange"
          range
          placeholder="Select Date Range"
          format="YYYY-MM-DD"
          :disabled-date="disabledDate"
          @change="filterRangeChanged"
        >
        </date-picker>
      </div>
      <div class="compliance-filter-export-button" v-if="isShowExportButton">
        <b-button class="is-primary" @click="exportData">
          &nbsp;&nbsp;<b-icon icon="download"></b-icon>&nbsp;&nbsp;
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import customDropdown from "../customDropdown.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import utitlityMixin from "@/mixins/UtilityMixin";
import Multiselect from "vue-multiselect";

export default {
  components: { customDropdown, DatePicker, Multiselect },
  name: "ComplianceFilter",
  mixins: [utitlityMixin],
  props: {
    filterSchemeDropDown: [],
    filterCountryDropDown: [],
    selectedCountry: [],
    selectedScheme: [],
    headerText: null
  },
  mounted() {
    this.headerText == "overview"
      ? (this.isShowExportButton = false)
      : (this.isShowExportButton = true);
  },
  watch: {
    headerText(newValue) {
      newValue == "overview"
        ? (this.isShowExportButton = false)
        : (this.isShowExportButton = true);
    },
    filterSchemeDropDown(newValue) {
      this.filterScheme = newValue.filter(
        (value, index, self) =>
          index ===
          self.findIndex(t => t.id === value.id && t.name === value.name)
      );
    },
    filterCountryDropDown(newValue) {
      this.filterCountry = newValue.filter(
        (value, index, self) =>
          index ===
          self.findIndex(t => t.id === value.id && t.name === value.name)
      );
    }
  },
  data() {
    return {
      countryForProduct: null,
      isShowExportButton: true,
      filterScheme: [],
      filterCountry: [],
      filterRange: [
        new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 3,
          new Date().getDate()
        ),
        new Date()
      ],
      allSelected: false,
      countries: [],
      selectedSortOptions: {
        name: "Highest Fee",
        value: "total_fee",
        order: "desc"
      },
      dropdownList: [
        { name: "Lowest Fee", value: "total_fee", order: "asc" },
        { name: "Highest Fee", value: "total_fee", order: "desc" },
        { name: "Lowest Sales", value: "sales", order: "asc" },
        { name: "Highest Sales", value: "sales", order: "desc" }
      ]
    };
  },
  methods: {
    loadProductByCountry() {
      this.$emit("loadProductByCountry", this.countryForProduct);
    },
    disabledDate(date, currentValue) {
      // While only the first end of the range has been picked, block any
      // date more than 3 months away from it so an invalid range can never
      // be selected in the first place.
      const anchor =
        currentValue && currentValue.length === 1 ? currentValue[0] : null;
      if (!anchor) return false;
      const minDate = new Date(anchor);
      minDate.setMonth(minDate.getMonth() - 3);
      const maxDate = new Date(anchor);
      maxDate.setMonth(maxDate.getMonth() + 3);
      return date < minDate || date > maxDate;
    },
    filterRangeChanged(value) {
      // Emit both ends together — emitting "filterFrom"/"filterTo" as two
      // separate events caused the parent to call loadData() twice per
      // range pick, the first time with a stale "to" value.
      const [from, to] = value || [];
      this.$emit("dateRangeChanged", {
        from: this.dateFormatterNew(from),
        to: this.dateFormatterNew(to)
      });
    },
    selectedValue(value) {
      this.$emit("sortBy", value);
      this.selectedSortOptions = value;
    },
    selectCountries(value) {
      if (value[1]) {
        this.$emit("selectedCountry", value[0]);
      }
    },
    selectedSchemes(value) {
      this.$emit("selectedSchemes", value[0]);
    },
    exportData() {
      this.$emit("exportData");
    }
  }
};
</script>
